// extracted by mini-css-extract-plugin
export default {"container":"R2pA","header":"_Ppn","fields":"t7Q8","actions":"SpHX","btn":"_8fpd","red":"GRys","blue":"B7sH"};